import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import { markPendingPrescriptionReminder } from '@/util/prescriptionReminder';

const baseRole = Constant.RoleList;

const state = {
  messageCenterList: [],
  messageCenterNotification: false
};
const mutations = {
  SETmessageCenterList(st, data) {
    st.messageCenterList = data;
  },
  SETmessageCenterNotification(st, status) {
    st.messageCenterNotification = status;
  }
};

const actions = {
  SETmessageCenterList({ commit, dispatch }, data) {
    commit('SETmessageCenterList', data);
  },
  async GetmessageCenterNotification({ commit, dispatch }) {
    // 获取消息中心状态
    const prams = {
      type: 'all'
    };
    const res = await Fetch.have_messages({ ...prams });
    if (res?.hasUnRead === true) {
      commit('SETmessageCenterNotification', true);
    } else {
      commit('SETmessageCenterNotification', false);
    }

    // 查询待审处方消息
    const roles = [baseRole.b, baseRole.f];
    if (hasPermission(roles)) {
      const result = await Fetch.have_messages({ type: 'pharmacist', ts: Date.now() });

      if (result?.hasUnRead === true) {
        markPendingPrescriptionReminder();
        dispatch('global/SETnotification', true, { root: true });
      }
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
